// @noflow
import moment from 'moment-timezone';

export default () => next => action =>
    next({
        ...action,
        meta: {
            ...action.meta,
            activityStamp: moment().valueOf()
        }
    });



// WEBPACK FOOTER //
// ./src/middleware/timestamp/index.js